import { Link } from "react-router-dom";
import type { Work } from "@/types/work";
import { workTypeLabel } from "@/lib/workUtils";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title}海报`}
          title={`${work.title} 剧情介绍与演员信息`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-950/80 px-2 py-1 text-[11px] font-semibold text-background-50 backdrop-blur">
          {workTypeLabel(work.type)}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-bold text-primary-950">
          <i className="ri-star-fill text-[11px]" />
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {work.year} · {work.region} · {work.status}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {work.synopsis}
        </p>
      </div>
    </Link>
  );
}